import { FieldsEnum, ModelPathEnum } from 'app/shared/enums';

export const getModelPathByField = (field: FieldsEnum) => {
  switch (field) {
    case FieldsEnum.OwnerBirthDate:
      return ModelPathEnum.MainOwnerBirthDate;
    case FieldsEnum.OwnerGender:
      return ModelPathEnum.MainOwnerGender;
    case FieldsEnum.Coowners1BirthDate:
      return ModelPathEnum.Coowners1BirthDate;
    case FieldsEnum.Coowners1Gender:
      return ModelPathEnum.Coowners1Gender;
    case FieldsEnum.Coowners2BirthDate:
      return ModelPathEnum.Coowners2BirthDate;
    case FieldsEnum.Coowners2Gender:
      return ModelPathEnum.Coowners2Gender;
  }
};
